<peab-grid>
  <peab-grid-cell columns="6">
  <peab-card>
    <peab-header class="site-error-header">
      <mat-icon class="site-error-icon">warning</mat-icon> {{ translations.siteErrorInfoHeader | translate }}
    </peab-header>
    <peab-text>
      {{ translations.siteErrorInfoText | translate }}
    </peab-text>
  </peab-card>
  </peab-grid-cell>
</peab-grid>
